import { defineComponent as n, createBlock as r, openBlock as a, unref as p, mergeProps as l, withCtx as m, createElementVNode as c } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const u = /* @__PURE__ */ n({
  name: "IconUndo",
  __name: "IconUndo",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (i, e) => (a(), r(p(s), l(t, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        c("path", { d: "M7.427 5.53a.75.75 0 0 0-1.06-1.06L2.72 8.116a1.25 1.25 0 0 0 0 1.768l3.646 3.646a.75.75 0 0 0 1.06-1.06L4.708 9.75h11.19a4.25 4.25 0 1 1 0 8.5h-3a.75.75 0 0 0 0 1.5h3a5.75 5.75 0 0 0 .001-11.5H4.707l2.72-2.72" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
